const data = [
  // { name: 'Meu Perfil', icon: 'mdi-account-edit-outline', route: '/profile' },
  { name: 'Cancelar notificações', icon: 'mdi-bell-off-outline', event: 'disable-notifications' },
  { name: 'Sair', icon: 'mdi-logout', event: 'logout' },
]

export default [...data]
